import PromoCard from './promoCard.component';

export default PromoCard;
